import axios from 'axios';
import fishbowlHelper from '../helpers/services/fishbowl';
import utilities from '../helpers/utility';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  async searchOrder(searchPayload) {
    const lookupPayload = {
      orderNumber: searchPayload.orderNumber || '',
      email: searchPayload.email || '',
      totalPrice: searchPayload.totalPrice || '',
      customerPurchaseOrder: searchPayload.customerPurchaseOrder || '',
      address: {
        name: searchPayload.name || '',
        street: searchPayload.street || '',
        city: searchPayload.city || '',
        zip: searchPayload.zip || '',
        state: searchPayload.state || '',
        country: searchPayload.country || '',
      }
    };

    if (utilities.deepEntries(lookupPayload).map(i => i[1]).filter(i => typeof i === 'string' && i != '').length == 0) {
      return [];
    }

    return axios({
      method: 'post',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/fishbowl/search`,
      data: lookupPayload,
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      console.error(error);
      return [];
    });
  },
  getSalesOrder(soNum) {
    return axios.get(`${BASE_API}/fishbowl/order/${soNum}`).then(response => {
      return response.data
    }).catch(error => {
      if (error.message === "Request failed with status code 404") {
        return {
          exists: false,
          noSearchResults: true,
        };
      } else {
        console.error(error, JSON.stringify(error));
        throw error
      }
    });
  },
  getHouseOrderNumber(prefix) {
    return axios
      .get(`${BASE_API}/fishbowl/order/new-order-num/${prefix}`)
      .then( response => {
        if (response.data) {
          return response.data;
        }
        else {
          return [{ num: `${prefix}00000` }]
        }

      })
      .catch((error) => {
        console.error(error);
      })
  },
  getAwaitingPayment() {
    return axios
      .get(`${BASE_API}/fishbowl/reports/awaiting-payment`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
        return {
          exists: false,
          noSearchResults: true,
        };
      });
  },
  getKitContents(id) {
    return axios
      .get(`${BASE_API}/fishbowl/kit/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return {
          noResults: true,
        }
      })
  },
  getOrderPipeline() {
    return axios
      .get(`${BASE_API}/fishbowl/reports/pipeline`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
        return {
          exists: false,
          noSearchResults: true,
        };
      });
  },
  getRmahcShipOptions() {
    return axios
      .get(`${BASE_API}/fishbowl/shipping/rmahc-options`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
        return [];
      });
  },
  async getHcTypes() {
    return axios
      .get(`${BASE_API}/fishbowl/product/hc-options`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
        return [];
      });
  },
  getPick(pickNum) {
      return axios.get(`${BASE_API}/fishbowl/pick/${pickNum}`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
      })
  },
  getPayments(num) {
    return axios.get(`${BASE_API}/fishbowl/payments/${num}`).then(response => response.data.map( e => {
      e.amount = Number(e.amount);
      return e;
    }))
    .catch((err) => {
      console.error(err);
    })
  },
  getPurchaseHistory(partNum) {
      return axios.get(`${BASE_API}/fishbowl/purchase-history/${partNum}`)
      .then(response => response.data)
      .catch((error) => {
        console.error(error);
      })
  },
  searchProduct(sku) {
    return axios.get(`${BASE_API}/fishbowl/product/${sku}`).then(response => {
      return response.data
    }).catch(err => {
      console.error(err)
    })
  }
};



// WEBPACK FOOTER //
// /src/services/fishbowl.js